module.exports = "/_next/static/images/jen-tseeng-61a58f47ada2fb30a09f579bda2c8b04.jpg";